'use client';
import { useEffect } from 'react';
import { useInternalOptionalSwanI18nContext } from '../contexts/i18n/swan-i18n-provider.context.js';

function getDeprecatedI18nPropMessage(e) {
    return e ? 'This prop is no longer needed as it is handled by the internal i18n system.' : "This prop has been replaced by SWAN's i18n system. Please opt into i18n and then remove this prop";
}
function useRequiredI18nProps(n, o) {
    let r = useInternalOptionalSwanI18nContext();
    useEffect(()=>{
        let e = [];
        if (null == r) {
            for (let t of o) void 0 === n[t] && e.push(t);
            e.length && console.warn(`The '${e.join(', ')}' prop/s are required. Either opt into SWAN's internationalisation support, or pass the props directly.`);
        }
    }, [
        r,
        o,
        n
    ]);
}

export { getDeprecatedI18nPropMessage, useRequiredI18nProps };
